import { render, staticRenderFns } from "./ChoujianDetail.vue?vue&type=template&id=70e21a4f&scoped=true"
import script from "./ChoujianDetail.vue?vue&type=script&lang=js"
export * from "./ChoujianDetail.vue?vue&type=script&lang=js"
import style0 from "./ChoujianDetail.vue?vue&type=style&index=0&id=70e21a4f&prod&lang=less&scoped=true"
import style1 from "./ChoujianDetail.vue?vue&type=style&index=1&id=70e21a4f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e21a4f",
  null
  
)

export default component.exports